export const ROUTE_PATH = {
    MAIN: '/',
    AREA: '/area',
    BRANDS: '/brands',
    CONTACTS: '/contacts',
    PRIVACY: '/privacy',
    TERMS: '/terms',
    STATUS: 'https://customer.axisrepair.com'
}